// product-form.js (HARDENED - prevents Add to Cart crashes)
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) {
          console.warn('product-form: no <form> found inside <product-form>.');
          return;
        }

        // Ensure variant id input exists and is enabled (Dawn-style behavior)
        const idInput = this.form.querySelector('[name="id"]');
        if (idInput) idInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          null;

        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) {
          console.warn('product-form: submit button not found.');
          return;
        }

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Optional elements (may not exist in your markup)
        this.spinner = this.querySelector('.loading-overlay__spinner') || null;

        // Error message container (optional)
        this.errorMessageWrapper =
          this.querySelector('.product-form__error-message-wrapper') || null;
        this.errorMessage = this.querySelector('.product-form__error-message') || null;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // UI loading state (guarded)
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        if (this.spinner) this.spinner.classList.remove('hidden');

        // If your theme lacks fetchConfig/routes/publish, fall back to normal submit
        const canAjax =
          typeof fetchConfig === 'function' &&
          window.routes &&
          window.routes.cart_add_url;

        if (!canAjax) {
          // restore minimal UI and submit normally
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          if (this.spinner) this.spinner.classList.add('hidden');
          this.form.submit();
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          try {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            if (typeof this.cart.setActiveElement === 'function') {
              this.cart.setActiveElement(document.activeElement);
            }
          } catch (e) {
            // don’t block add to cart if section rendering fails
            console.warn('product-form: cart sections render setup failed', e);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Publish error if pubsub exists
              if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.description,
                  message: response.message
                });
              }

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton && this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', 'true');
                const span = this.submitButton.querySelector('span');
                if (span) span.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }

              this.error = true;
              return;
            }

            // No cart drawer? go to cart
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error && typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id')
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal && typeof quickAddModal.hide === 'function') {
              quickAddModal.hide(true);
            }

            // Render cart sections if cart supports it
            if (typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(response);
            }

            if (window.InnerNerdCartSync) {
              window.InnerNerdCartSync.refresh();
            }
            document.dispatchEvent(new CustomEvent('innernerd:cartAdded', {
              detail: { variant_id: formData.get('id'), quantity: Number(formData.get('quantity') || 1) },
              bubbles: true
            }));
          })
          .catch((e) => {
            console.error('product-form: add to cart failed', e);
          })
          .finally(() => {
            // Restore UI state (guarded)
            if (!this.submitButton) return;
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (this.spinner) this.spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        // If your markup doesn’t have an error wrapper, don’t crash
        if (!this.errorMessageWrapper || !this.errorMessage) return;

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
